import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './style.scss';

const Checkbox = (props) => {
  const handleOnChange = () => {
    const { onChange, isChecked } = props;
    onChange(!isChecked);
  };

  const { isChecked, className, errorMessage, label, id, containerClass, ...rest } = props;

  return (
    <div className={cn('checkboxWrapper', containerClass)}>
      <label className={cn(className, 'form-check', isChecked ? 'checked' : '')}>
        <div className="row">
          <div className="col-auto">
            <input
              type="checkbox"
              value={isChecked}
              onChange={handleOnChange}
              {...rest}
            />
          </div>
          <div className="col">
            {label}
          </div>
        </div>
      </label>
      <span className="error">{errorMessage}</span>
    </div>
  );
};

Checkbox.propTypes = {
  onChange: PropTypes.func,
  isChecked: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  errorMessage: PropTypes.string,
  containerClass: PropTypes.string,
};

Checkbox.defaultProps = {
  onChange: () => {},
  isChecked: false,
  label: [],
  name: '',
  className: '',
  errorMessage: '',
  id: '',
  containerClass: '',
};

export default Checkbox;
